import axios from "axios";

const AJOUTER_VERIFICATION_SPECIFIQUE = `${process.env.REACT_APP_API_URL}/lea/exercice/verification-specifique/ajouter`
const LISTE_VERIFICATION_SPECIFIQUE = `${process.env.REACT_APP_API_URL}/lea/exercice/verification-specifique`

export const ajouterVerificationSpecifique = async (data) => {
    return axios.post(AJOUTER_VERIFICATION_SPECIFIQUE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeVerificationSpecifique = async (exercice_id, codeSommaire) => {
    return axios.get(`${LISTE_VERIFICATION_SPECIFIQUE}/${exercice_id}/${codeSommaire}`).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}